// This entrypoint handles all wagtail admin related functionality.

// polyfills must come first in case any of the other imports use new syntax.
import './polyfills';

import ReactHabitat from 'react-habitat';

import 'core/draftail/tagger';

import ChakraDomFactory from "./react_registry";
import theme from 'frontend/adminTheme'

class AnvilAdminApp extends ReactHabitat.Bootstrapper {
    constructor() {
        super();
        const builder = new ReactHabitat.ContainerBuilder();
        builder.factory = new ChakraDomFactory(theme)

        builder.registerAsync(() => import("business_directory/admin/TreeEditor").then(m => m.default)).as('TreeEditor');
        builder.registerAsync(() => import("video_gallery/VideoPlayer").then(m => m.default)).as('VideoPlayer');
        builder.registerAsync(() => import('audience/AudienceCharts').then(m => m.default)).as('AudienceCharts');
        builder.registerAsync(() => import('autopay/AutopayManager')).as('AutopayManager');
        builder.register(() => null).as("add-comment-button")
        builder.registerAsync(() => import('frontend/manual_billing/screens/ManualBilling')).as('ManualBilling');
        builder.registerAsync(() => import('frontend/payment_sync/screens/PaymentSync')).as('PaymentSync');
        builder.registerAsync(() => import('frontend/batch_rate_change_upload/screens/BatchChangeRateUpload.jsx')).as('BatchChangeRateUpload');
        builder.registerAsync(() => import('frontend/single_copy_fe/BatchPayments/screens/BatchPaymentEntry.jsx')).as('BatchPaymentEntry');
        builder.registerAsync(() => import('frontend/subscriber/Admin/BatchPayment/BatchPayment.jsx')).as('SubscriberBatchPaymentEntry');
        builder.registerAsync(() => import('frontend/subscriber/Admin/reports/TaxReport.jsx')).as('SubscriberTaxReport');
        builder.registerAsync(() => import('frontend/subscriber/Admin/paymenmts/ApplyPayment.jsx')).as('ApplyPayment');
        builder.registerAsync(() => import('frontend/subscriber/Admin/actions/LinkBraintreeCustomer.jsx')).as('LinkBraintreeCustomer');
        builder.registerAsync(() => import('frontend/single_copy_fe/BatchPayments/screens/SinglePayment.jsx')).as('SinglePaymentEntry');
        builder.registerAsync(() => import('frontend/subscriber/Admin/pauses/ManagePauses.jsx')).as('ManagePauses');
        builder.registerAsync(() => import('frontend/ai_assistant/components/AnvilAI.jsx')).as('AnvilAI');
        builder.registerAsync(() => import('frontend/ai_assistant/components/SEOAnalysis.jsx')).as('SEOAnalysis');
        builder.registerAsync(() => import('frontend/single_copy_fe/AccountInspect/screens/AccountInspect.jsx')).as('AccountInspect');

        this.setContainer(builder.build());
    }

}

const app = new AnvilAdminApp();

document.addEventListener('DOMContentLoaded', () => {
    app.update()
});

export default app;
